import { observable, action, computed } from "mobx"
import { getChunkCount } from "../tools/uploadTools"
export const SUCCESS = "success"
export const EXCEPTION = "exception"
export const ACTIVE = "active"
export const INACTIVE = "inactive"
import { TASK_TYPE } from "./TaskModel"
/*
 * file, progress, name, shortName, size, chunkCount
 */
export default class {
  type = TASK_TYPE.file
  errorInfo = null
  @observable file = {}
  @observable isQuickUpload = false
  @observable reference = false
  @observable progress = 0 // range(101)
  @observable status = INACTIVE // success, exception, active, inactive
  @observable shortName: ""

  constructor (file) {
    this.file = file
    this.name = file.name
    this.size = file.size
    this.chunkCount = getChunkCount(file.size)
  }

  @action setQuickUpload () {
    this.isQuickUpload = true
  }

  @action setError (info) {
    this.errorInfo = info
    this.status = EXCEPTION
  }

  @action setSuccess () {
    this.status = SUCCESS
  }

  @action setActive () {
    this.status = ACTIVE
  }

  @computed get isError () {
    return this.status === EXCEPTION
  }

  @computed get isSuccess () {
    return this.status === SUCCESS
  }

  @computed get isActived () {
    return this.status === ACTIVE
  }

  @computed get isInactived () {
    return this.status === INACTIVE
  }

  @action updateProgress (progress) {
    this.progress = progress
    this.status = ACTIVE // 为了应对重新发起的任务
  }

  @action updateShortName(value) {
    this.shortName = value
  }
}



// WEBPACK FOOTER //
// ./src/app/components/normal/BasicModal/UploadModal/stores/File.js